import React, { useMemo } from "react";

import { colors } from "@zapalacorp/tokens";
import SkeletonComponent from "Components/Generic/Skeleton";
import { Archive, RouteSquare, Task, TaskSquare, TickSquare } from "iconsax-react";
import { OrdersManagementWidgets } from "Models/report.orders.management";
import { useTranslation } from "react-i18next";

import { ManagementWidgetsContainer } from "./styles";
import { ManagementWidgetItem } from "./widgetItem";

interface ManagementWidgetProps {
  widgets: OrdersManagementWidgets | undefined;
  isLoading: boolean;
}
const ICON_COLOR = colors.gray200;
const ICON_SIZE = 60;

export const ManagementWidgets = ({ widgets, isLoading }: ManagementWidgetProps) => {
  const { t: translate } = useTranslation();
  const widgetItems = useMemo(
    () => [
      {
        title: translate("totalOrders"),
        value: widgets?.totalOrders,
        icon: <Archive size={ICON_SIZE} color={ICON_COLOR} />,
      },
      {
        title: translate("ordersCompleted"),
        value: widgets?.ordersCompleted,
        icon: <TickSquare size={ICON_SIZE} color={ICON_COLOR} />,
      },
      {
        title: translate("inProgress"),
        value: widgets?.ordersInProgress,
        icon: <RouteSquare size={ICON_SIZE} color={ICON_COLOR} />,
      },
      {
        title: translate("totalTasks"),
        value: widgets?.totalTasks,
        icon: <Task size={ICON_SIZE} color={ICON_COLOR} />,
      },
      {
        title: translate("tasksCompleted"),
        value: widgets?.totalTasksCompleted,
        icon: <TaskSquare size={ICON_SIZE} color={ICON_COLOR} />,
      },
    ],
    [widgets]
  );

  return (
    <ManagementWidgetsContainer>
      {widgetItems.map(({ title, value, icon }) => (
        <SkeletonComponent key={title} isLoading={isLoading}>
          <ManagementWidgetItem title={title?.toUpperCase()} value={value ?? 0} icon={icon} />
        </SkeletonComponent>
      ))}
    </ManagementWidgetsContainer>
  );
};
